// Shared field validators, mirroring the backend jakarta @Pattern rules
// (backend common/ValidationPatterns.java) so the browser and server agree on what's valid.
//
// Plain regex on purpose — not zod/react-hook-form: the rules are three lines, every form here
// already uses the same inline `error`/`helperText` idiom, and this repo's pnpm can't install new
// deps (see CLAUDE.md). Swap in zod if the forms ever grow real cross-field logic.
//
// All three treat empty as valid (presence is the caller's `!value.trim()` check), so they compose:
// `!name.trim() || !isPersonName(name)`.

export const isEmail = (v: string) => v.trim() === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim())

/** Digits + separators (+ ( ) - space); rejects letters. Lenient on length like the backend. */
export const isPhone = (v: string) => v.trim() === '' || /^\+?[0-9][0-9 ()\-]*$/.test(v.trim())

/** Unicode letters + space, apostrophe, hyphen, dot; rejects digits. Person names only. */
export const isPersonName = (v: string) => v.trim() === '' || /^\p{L}[\p{L} .'\-]*$/u.test(v.trim())

/** An http(s):// link — image, logo and banner URLs are shown as pictures, so nothing else (D-115). */
export const isHttpUrl = (v: string) => v.trim() === '' || /^https?:\/\/\S+$/i.test(v.trim())
